import { render } from "./AppTopBar.vue?vue&type=template&id=158c4ba2&scoped=true"
import script from "./AppTopBar.vue?vue&type=script&lang=js"
export * from "./AppTopBar.vue?vue&type=script&lang=js"

import "./AppTopBar.vue?vue&type=style&index=0&id=158c4ba2&scoped=true&lang=css"

import exportComponent from "/opt/compla/docker/sites/my-atw-global/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158c4ba2"]])

export default __exports__